module.exports = __webpack_public_path__ + "static/media/new-york-47.bf661f8a.jpg";